import { LitElement } from "lit";
import { outlet } from "lit-element-router";
import { html } from "lit-html";

class RouterOutlet extends outlet(LitElement) {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  render() {
    return html` <slot></slot> `;
  }
}

customElements.define("router-outlet", RouterOutlet);
